/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signupstateopen2Inputs */

const en_signupstateopen2 = /** @type {(inputs: Signupstateopen2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open`)
};

const de_signupstateopen2 = /** @type {(inputs: Signupstateopen2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offen`)
};

/**
* | output |
* | --- |
* | "Open" |
*
* @param {Signupstateopen2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signupstateopen2 = /** @type {((inputs?: Signupstateopen2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signupstateopen2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signupstateopen2(inputs)
	return de_signupstateopen2(inputs)
});
export { signupstateopen2 as "signupStateOpen" }